;(function () {
    function NavigationController() {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * Both navigations are always initialized to prevent issues when changing the viewport size
         */
        this.init = function () {
            _this.initMenuButton()
            _this.initMobileNavigationAccordion()
            _this.desktopThirdLevelOpenStateTimeExtension()
        }

        /**
         * Initializes menu button to open both menus on click and display the correct icon
         */
        this.initMenuButton = function () {
            let buttons = document.querySelectorAll('[rel="main-navigation-button"]')
            let container = document.querySelector('[rel="main-navigation"]')
            let mobileContainer = document.querySelector('[rel="mobile-navigation"]')

            buttons.forEach(function (button) {
                button.addEventListener('click', function () {
                    if (container !== null) {
                        container.classList.toggle('active')
                    }
                    mobileContainer.classList.toggle('active')
                    button.classList.toggle('active')
                    button.classList.toggle('icon-menu-left')
                    button.classList.toggle('icon-menu-close-left')
                })
            })
        }

        /**
         * Initializes accordion displayed in the mobile menu
         */
        this.initMobileNavigationAccordion = function () {
            let container = document.querySelector('[rel="main-navigation"]')
            let mode = container.dataset ? container.dataset['navigationMode'] : 'simple'
            let accordionLevel = mode === 'simple' ? 1 : 2

            let items = document.querySelectorAll('[rel="mobile-navigation-item-level-' + accordionLevel + '"]')
            items.forEach(function (item) {
                let button = item.querySelector('[rel="mobile-navigation-button"]')

                let list = item.querySelector('[rel="mobile-navigation-list-level-' + accordionLevel + '"]')
                if (list !== null && button !== null) {
                    button.addEventListener('click', function () {
                        list.classList.toggle('mobile-navigation-active-list')
                        button.classList.toggle('icon-arrow-menu-close-right')
                        button.classList.toggle('icon-arrow-menu-open-right')
                    })
                }
            })

            // simple mode, but has second level navigation
            if (mode === 'simple') {
                _this.initMobileNavigationSimpleModeSecondLevelAccordion()
            }
        }

        /**
         * Initializes simple mode second level accordion displayed in the mobile menu
         */
        this.initMobileNavigationSimpleModeSecondLevelAccordion = function () {
            var secondLevelButtons = document.querySelectorAll(
                '.simple-mobile-navigation-label-level-2 > [rel="mobile-navigation-button"]'
            )
            if (secondLevelButtons.length >= 1) {
                secondLevelButtons.forEach(function (item) {
                    item.addEventListener('click', function () {
                        var mobileNavigationListLevel2 = item
                            .closest('[rel="mobile-navigation-item-level-2"]')
                            .querySelector('[rel="mobile-navigation-list-level-2"]')
                        mobileNavigationListLevel2.classList.toggle('mobile-navigation-active-list')
                        item.classList.toggle('icon-arrow-menu-close-right')
                        item.classList.toggle('icon-arrow-menu-open-right')
                    })
                })
            }
        }

        /**
         *
         *  Extend the time for hovered state of Desktop Third Level Navigation
         */
        this.desktopThirdLevelOpenStateTimeExtension = function () {
            var desktopSecondLevelLabelElements = document.querySelectorAll(
                '[rel="simple-main-navigation-label-level-2"]'
            )

            var nextSibling = null

            var previousSibling = null

            desktopSecondLevelLabelElements.forEach(function (item) {
                item.addEventListener('mouseover', function () {
                    if (!item.classList.contains('js__hovered')) {
                        item.classList.add('js__hovered')

                        // Make current siblings temporarily disabled the mouse event
                        var parent = item.closest('[rel="simple-main-navigation-item-level-2"]')

                        nextSibling = parent.nextSibling
                            ? parent.nextSibling.querySelector('[rel="simple-main-navigation-label-level-2"]')
                            : null
                        if (nextSibling) {
                            nextSibling.classList.add('js__mouse-event-disabled')
                        }

                        previousSibling = parent.previousSibling
                            ? parent.previousSibling.querySelector('[rel="simple-main-navigation-label-level-2"]')
                            : null
                        if (previousSibling) {
                            previousSibling.classList.add('js__mouse-event-disabled')
                        }
                    }
                })

                item.addEventListener('mouseout', function () {
                    var wait
                    wait = setTimeout(function () {
                        item.classList.remove('js__hovered')

                        // Reset current siblings mouse event
                        if (nextSibling) {
                            nextSibling.classList.remove('js__mouse-event-disabled')
                        }
                        if (previousSibling) {
                            previousSibling.classList.remove('js__mouse-event-disabled')
                        }
                        clearTimeout(wait)
                    }, 200)
                })
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Energy = window.Energy || {}

    window.Energy.NavigationController = NavigationController
})()

if (document.readyState !== 'loading') {
    new window.Energy.NavigationController()
} else {
    document.addEventListener('DOMContentLoaded', new window.Energy.NavigationController())
}
